import * as React from 'react';
import intl from 'react-intl-universal';
import { find } from 'lodash';
import { ConfigProvider } from 'antd-mobile';
import { Locale } from 'antd-mobile/es/locales/base';

import { useOnMount } from '@utils/hook';
import { setCookie, queryURL } from '@utils/index';
import { GLOBAL_KEYS } from '@constants/index';
import { LOCALES_KEYS, getLocaleLoader, SUPPOER_LOCALES } from '@locales/loaders';
import PageLoading from '@components/PageLoading';

interface IProps {
    children?: React.ReactNode;
}

export default function IntlWrapper({ children }: IProps) {
    const [currentLocale, setCurrentLocale] = React.useState<LOCALES_KEYS | undefined>(undefined);
    const [antdCurrentLocale, setAntdCurrentLocale] = React.useState<Locale>();

    function loadLocales() {
        const lang =
            queryURL('lang') && [LOCALES_KEYS.EN_US, LOCALES_KEYS.ZH_CN].includes(queryURL('lang'))
                ? queryURL('lang')
                : LOCALES_KEYS.ZH_CN;
        setCookie(GLOBAL_KEYS.LANG, lang);

        let targetLocale = intl.determineLocale({ cookieLocaleKey: GLOBAL_KEYS.LANG }) as LOCALES_KEYS;

        if (!find(SUPPOER_LOCALES, { value: targetLocale })) {
            targetLocale = LOCALES_KEYS.ZH_CN;
        }

        getLocaleLoader(targetLocale).then(res => {
            intl.init({ currentLocale: targetLocale, locales: { [targetLocale]: res.localeData } }).then(() => {
                setCurrentLocale(targetLocale);
                setAntdCurrentLocale(res.antdLocaleData);
            });
        });
    }

    useOnMount(loadLocales);

    if (!currentLocale) {
        return <PageLoading />;
    }

    return (
        <ConfigProvider locale={antdCurrentLocale!}>
            <React.Fragment>{children}</React.Fragment>
        </ConfigProvider>
    );
}
